// generated file: do not edit
import Character from "../../engine/character";
import Glyphs from "./glyphs";
import belgranoStory from "../stories/belgrano.ink.json";
import belgranosKeysStory from "../stories/belgranosKeys.ink.json";
import edwardsStory from "../stories/edwards.ink.json";
import garrenStory from "../stories/garren.ink.json";
import leeStory from "../stories/lee.ink.json";
import rangefinderStory from "../stories/rangefinder.ink.json";
import differentVeilStory from "../stories/differentVeil.ink.json";
import fogSighterStory from "../stories/fogSighter.ink.json";
import helmsmanStory from "../stories/helmsman.ink.json";
import navigatorStory from "../stories/navigator.ink.json";
import quartermasterStory from "../stories/quartermaster.ink.json";
import salvagerStory from "../stories/salvager.ink.json";
import seaCaptainStory from "../stories/seaCaptain.ink.json";
import boyStory from "../stories/boy.ink.json";
import motherStory from "../stories/mother.ink.json";
import shouldTheyTryStory from "../stories/shouldTheyTry.ink.json";
import suspiciousManStory from "../stories/suspiciousMan.ink.json";
import takeAMomentStory from "../stories/takeAMoment.ink.json";
import wolfLeaderStory from "../stories/wolfLeader.ink.json";
import bridgepersonStory from "../stories/bridgeperson.ink.json";
import explorerStory from "../stories/explorer.ink.json";
import professorStory from "../stories/professor.ink.json";
import tunneltotemStory from "../stories/tunneltotem.ink.json";
import irisStory from "../stories/iris.ink.json";
import villageheadStory from "../stories/villagehead.ink.json";
import garlandStory from "../stories/garland.ink.json";
import MVINPC_EvidanceBoxStory from "../stories/MVINPC_EvidanceBox.ink.json";
import MVINPC_FatherDavidStory from "../stories/MVINPC_FatherDavid.ink.json";
import MVINPC_MayorHamishStory from "../stories/MVINPC_MayorHamish.ink.json";
import MVINPC_MineEntranceManStory from "../stories/MVINPC_MineEntranceMan.ink.json";
import MVINPC_MiningAdultStory from "../stories/MVINPC_MiningAdult.ink.json";
import MVINPC_MiningChildStory from "../stories/MVINPC_MiningChild.ink.json";
import MVINPC_NunStory from "../stories/MVINPC_Nun.ink.json";
import MVINPC_Sherif_AldenStory from "../stories/MVINPC_Sherif_Alden.ink.json";
import MVINPC_TimmyStory from "../stories/MVINPC_Timmy.ink.json";
import inDemandStory from "../stories/inDemand.ink.json";
import stripTheValleyStory from "../stories/stripTheValley.ink.json";
import hermTheHermitStory from "../stories/hermTheHermit.ink.json";
import treasureStory from "../stories/treasure.ink.json";
import grasstotemStory from "../stories/grasstotem.ink.json";
import stonetotemStory from "../stories/stonetotem.ink.json";
import bonVoyageStory from "../stories/bonVoyage.ink.json";
import drowningSailorStory from "../stories/drowningSailor.ink.json";
import pirateBattleStory from "../stories/pirateBattle.ink.json";
import seaBeastStory from "../stories/seaBeast.ink.json";
import unusualWreckStory from "../stories/unusualWreck.ink.json";
import captainbobStory from "../stories/captainbob.ink.json";
import secretWizardStory from "../stories/secretWizard.ink.json";

class Characters {
  static belgrano(stage) {
    return new Character(
      "belgrano",
      Glyphs.Belgrano,
      8,
      {"look":"A grizzled old sea dog watching the guns.","bump":"{belgranoQuips}","belgranoQuips":["“Be on yer way now...”","“Arr, the gulls are circling lazy-like today.”","“All quiet out there today.”","“The hell’d I leave me spyglass?”"]},
      belgranoStory,
      stage
    );
  }
static belgranosKeys(stage) {
    return new Character(
      "belgranosKeys",
      Glyphs.BelgranosKeys,
      8,
      {"look":"A pile of keys sits on the desk.","bump":"The keys are on the desk."},
      belgranosKeysStory,
      stage
    );
  }
static edwards(stage) {
    return new Character(
      "edwards",
      Glyphs.Edwards,
      8,
      {"look":"A Police Officer stands behind the desk at the office.","bump":"'{edwardsQuips}'","edwardsQuips":["“Good day.”","“I'll see you around.”","“Don't cause any trouble.”"]},
      edwardsStory,
      stage
    );
  }
static garren(stage) {
    return new Character(
      "garren",
      Glyphs.Garren,
      8,
      {"look":"A seething Shipment Officer.","bump":"{Quips}","Quips":["“Thank you for bringing this to our attention.”","“My condolences, by the way.”","“The Captain was a friend of mine once, I'm sorry to hear he's passed on.”","“Caldera's waters will be safer now that we're vigilant.”"]},
      garrenStory,
      stage
    );
  }
static lee(stage) {
    return new Character(
      "lee",
      Glyphs.Lee,
      8,
      {"look":"A young police officer stands at the entrace to Nelson's Reach","bump":"'{leeQuips}'","leeQuips":["“ello squire.”","“ello squire, pleasant day ain’t it?”","“Good day sir.”"]},
      leeStory,
      stage
    );
  }
static rangefinder(stage) {
    return new Character(
      "rangefinder",
      Glyphs.Rangefinder,
      8,
      {"look":"A rangefinder sits on the desk.","bump":"The rangefinder sits on the desk, it is well maintained."},
      rangefinderStory,
      stage
    );
  }
static differentVeil(stage) {
    return new Character(
      "differentVeil",
      Glyphs.DifferentVeil,
      8,
      {"look":"A fisherwoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["tending to her vegetable garden.","struggling to untangle her vegetables from weeds.","exchanging a smile with her partner, hoping to make the work lighter.","clearly frustrated at the poor soil of her garden."],"barkDetail":["(She gives a warm, but weary smile.)","“We need to support each other, all of us.”","“It's hard work, but this garden, and her fishing, make up our entire livelihood.”","“Think it might rain soon?”"]},
      differentVeilStory,
      stage
    );
  }
static fogSighter(stage) {
    return new Character(
      "fogSighter",
      Glyphs.FogSighter,
      8,
      {"look":"A teenage boy {moreDetail}","bump":"{barkDetail}","moreDetail":["with fear in his eyes.","from the village, with not much experience.","hanging about the docks with little to do."],"barkDetail":["“I'm sorry I couldn't help”","“You'll find it, won't you?”","(Polite, but weary, smile and nod.)"]},
      fogSighterStory,
      stage
    );
  }
static helmsman(stage) {
    return new Character(
      "helmsman",
      Glyphs.Helmsman,
      8,
      {"look":"A {descriptive} fisherman {moreDetail}","bump":"{barkDetail}","descriptive":["large, hairy","reddened and sunburnt","kind-eyed"],"moreDetail":["fastening a knot.","preparing his nets.","deboning a fish."],"barkDetail":["“Ahoy thar, Cap'n! Shame about ol' Omar. It's how he would've want'd to go.”","“A fine day for't.”","“Ah, th' smell of salt ne'er gets old.”","“Smooth sailin' to ye.”"]},
      helmsmanStory,
      stage
    );
  }
static navigator(stage) {
    return new Character(
      "navigator",
      Glyphs.Navigator,
      8,
      {"look":"A {descriptive} fisherwoman, {moreDetail}","bump":"{barkDetail}","descriptive":["vacant-eyed","daydreaming","bored"],"moreDetail":["sketching a map of Caldera on a flat canvas.","charting a course around the coastline with charcoal.","absent-mindedly playing with a pair of compasses at her desk."],"barkDetail":["“Hh-huh? Sorry, I was just dozing off.”","“Oh - hey Captain, how're you holding up?”","(Soft humming)","“Wind's a bit chilly outside, eh?”"]},
      navigatorStory,
      stage
    );
  }
static quartermaster(stage) {
    return new Character(
      "quartermaster",
      Glyphs.Quartermaster,
      8,
      {"look":"A {descriptive} fisherman, {moreDetail}","bump":"{barkDetail}","descriptive":["grumpy-looking","wrinkled and sleep-deprived","busy and unhappy"],"moreDetail":["counting a supply of fruits and vegetables.","organising rations of food for the village.","shifting heavy crates with a good deal of effort."],"barkDetail":["(Disinterested grunt)","“You looking for supplies?”","“I'm... sorry about the Captain.”","“Think it'll rain?”","“Uh-huh.”"]},
      quartermasterStory,
      stage
    );
  }
static salvager(stage) {
    return new Character(
      "salvager",
      Glyphs.Salvager,
      8,
      {"look":"A fisherwoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["tending to her vegetable garden.","struggling to untangle her vegetables from weeds.","clearly frustrated at the poor soil of her garden."],"barkDetail":["(Beleagured sigh.)","“This cannot last.”","“Why won't you grow - ”","“If only it'd rain!”","“Ahoy there, Captain. Thanks for gettin' us home in one piece.”"]},
      salvagerStory,
      stage
    );
  }
static seaCaptain(stage) {
    return new Character(
      "seaCaptain",
      Glyphs.SeaCaptain,
      8,
      {"look":"An ancient sea captain {moreDetail}","bump":"{barkDetail}","moreDetail":["staring out to the horizon.","barely visible amongst the fishing supplies.","with weary eyes."],"barkDetail":["“Arr, stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering.)"]},
      seaCaptainStory,
      stage
    );
  }
static boy(stage) {
    return new Character(
      "boy",
      Glyphs.Boy,
      8,
      {"look":"A young boy, {moreDetail}","bump":"{barkDetail}","moreDetail":["about ten years of age. He likes to play dangerously close to the woods.","who tends to play clumsily by the woods. If he's not careful, he'll get hurt.","who likes to throw stones at trees to scare birds."],"barkDetail":["“I'm sorry I ran off. I really am.”","“It won't happen again, I promise.”","(Shivering.)"]},
      boyStory,
      stage
    );
  }
static mother(stage) {
    return new Character(
      "mother",
      Glyphs.Mother,
      8,
      {"look":"A pregnant mother, {moreDetail}","bump":"{barkDetail}","moreDetail":["worried about things she can barely express.","managing well enough, with the weight of the world on her shoulders.","murmuring to herself, full of concern."],"barkDetail":["“I have to make this work or else - ”","“Thank you for everything. You're very welcome here.”","“It's hard providin' for my boy and I. I only wish it were easier.”","(Groaning with effort.)"]},
      motherStory,
      stage
    );
  }
static shouldTheyTry(stage) {
    return new Character(
      "shouldTheyTry",
      Glyphs.ShouldTheyTry,
      8,
      {"look":"A farmer, {moreDetail}","bump":"{barkDetail}","moreDetail":["tilling the soil with a hoe, grasped tightly.","with sweat running down her face, her knuckles white and her jaw clenched hard.","clearly frustrated at the poor soil, muttering something to herself in anger."],"barkDetail":["(Heavy, exhaustive sigh.)","“How dare they - ”","“Mark my words...”","“(Unintelligible muttering.)”","(She barely looks up at you.)"]},
      shouldTheyTryStory,
      stage
    );
  }
static suspiciousMan(stage) {
    return new Character(
      "suspiciousMan",
      Glyphs.SuspiciousMan,
      8,
      {"look":"A Suspicious Man, {moreDetail}","bump":"{barkDetail}","moreDetail":["holding an instrument you cannot recognise.","dressed richer than any Calderan you've encountered.","his eyes surveying the inlet."],"barkDetail":["(He has nothing to say to you.)"]},
      suspiciousManStory,
      stage
    );
  }
static takeAMoment(stage) {
    return new Character(
      "takeAMoment",
      Glyphs.TakeAMoment,
      8,
      {"look":"A young man, {moreDetail}","bump":"{barkDetail}","moreDetail":["sitting atop a fallen log, with his eyes gently closed.","humming a soft meditative tune.","practicing breathing exercises, away from the village bustle."],"barkDetail":["“Just take a moment.”","“Sit with me. Breathe it all in.”","“Listen to the birds - ”","“Storm's approaching. You can hear it in the birdsong.”","(Soft humming.)"]},
      takeAMomentStory,
      stage
    );
  }
static wolfLeader(stage) {
    return new Character(
      "wolfLeader",
      Glyphs.WolfLeader,
      8,
      {"look":"A hungry wolf, bigger than the others!","bump":"{barkDetail}","barkDetail":["(Growling.)"]},
      wolfLeaderStory,
      stage
    );
  }
static bridgeperson(stage) {
    return new Character(
      "bridgeperson",
      Glyphs.Bridgeperson,
      8,
      {"look":"A happy woman fishing on the bridge. {moreDetail}","bump":"{barkDetail} says the woman.","moreDetail":["She sees you and waves.","A big smile appears across her face.","She might catch something soon."],"barkDetail":["“Oh oops! Careful where you step.”","“Oh, I think I've caught something!”","“Hey there stranger.”","“Have you heard the legend?”"]},
      bridgepersonStory,
      stage
    );
  }
static explorer(stage) {
    return new Character(
      "explorer",
      Glyphs.Explorer,
      8,
      {"look":"A {descriptive} globetrotter {moreDetail}","bump":"{barkDetail}","descriptive":["tall and dark-haired","clean-shaven","well built"],"moreDetail":["sharpening tools.","sorting through supplies.","pacing, deep in thought."],"barkDetail":["“Hello!”","“Please be more careful in here.”","“These ruins are really bringing out the youth in me, haha!”","“Imagine the wealth that these ruins once possessed...”"]},
      explorerStory,
      stage
    );
  }
static professor(stage) {
    return new Character(
      "professor",
      Glyphs.Professor,
      8,
      {"look":"A {descriptive} intellectual {moreDetail}","bump":"{barkDetail}","descriptive":["slim and tall","moustached","grey-haired"],"moreDetail":["shuffling some papers.","reading a large tome.","sketching details on a map."],"barkDetail":["“Why hello there!”","“You really ought to be more careful.”","“This is truly a fascinating place.”","“Once I am done here I'll be renowned in the capital!”"]},
      professorStory,
      stage
    );
  }
static tunneltotem(stage) {
    return new Character(
      "tunneltotem",
      Glyphs.Tunneltotem,
      8,
      {"look":"The totem is in good condition compared to the rest of the ruins. Maybe because of the tunnel.","bump":"{barkDetail}","barkDetail":["The blue gem above glistens in the torchlight.","Carvings are present around the totem's sides.","The totem feels old, yet the stone has kept its shape well."]},
      tunneltotemStory,
      stage
    );
  }
static iris(stage) {
    return new Character(
      "iris",
      Glyphs.Iris,
      8,
      {"look":"A young girl picking flowers from the iris field.","bump":"'{irisQuips}'","irisQuips":["“Hello!”"]},
      irisStory,
      stage
    );
  }
static villagehead(stage) {
    return new Character(
      "villagehead",
      Glyphs.Villagehead,
      8,
      {"look":"A middle-aged gentleman reading a book. He seems to have noticed your presence without looking up at you.","bump":"{villager1Quips}","villager1Quips":["“Hello, and welcome to Elysia! My name is James, I'm the head of this village.”"]},
      villageheadStory,
      stage
    );
  }
static garland(stage) {
    return new Character(
      "garland",
      Glyphs.Garland,
      8,
      {"look":"An old Swagman sits by the road, boiling a billy.","bump":"“G'day mate!”"},
      garlandStory,
      stage
    );
  }
static MVINPC_EvidanceBox(stage) {
    return new Character(
      "MVINPC_EvidanceBox",
      Glyphs.MVINPC_EvidanceBox,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["On top of a small desk sits a book and a blood-soaked knife."],"barkDetail":["How evil..."]},
      MVINPC_EvidanceBoxStory,
      stage
    );
  }
static MVINPC_FatherDavid(stage) {
    return new Character(
      "MVINPC_FatherDavid",
      Glyphs.MVINPC_FatherDavid,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["A tall, skinny man wearing flowing white priest robes, stands before a simple wooden lectern overlooking a small assembled crowd."],"barkDetail":["Thank you, my child."]},
      MVINPC_FatherDavidStory,
      stage
    );
  }
static MVINPC_MayorHamish(stage) {
    return new Character(
      "MVINPC_MayorHamish",
      Glyphs.MVINPC_MayorHamish,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["A large man sits behind an opulent desk made of expensive imported wood. He sits slumped in a fancy wooden chair, very out of place for the small town. Upon his desk sits chinaware and fancy ornaments from around the world."],"barkDetail":["Thank you."]},
      MVINPC_MayorHamishStory,
      stage
    );
  }
static MVINPC_MineEntranceMan(stage) {
    return new Character(
      "MVINPC_MineEntranceMan",
      Glyphs.MVINPC_MineEntranceMan,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["A man stands, operating the mine carts as they careen up and down the steep cliff."],"barkDetail":["Thanks for visiting! Please, don't come back."]},
      MVINPC_MineEntranceManStory,
      stage
    );
  }
static MVINPC_MiningAdult(stage) {
    return new Character(
      "MVINPC_MiningAdult",
      Glyphs.MVINPC_MiningAdult,
      8,
      {"look":"A burly looking miner lays slumped over, {moreDetail}","bump":"{barkDetail}","moreDetail":["his pick laying across his legs.","his pack behind him.","collecting himself on the cold hard ground."],"barkDetail":["I ain't got anything to say to you."]},
      MVINPC_MiningAdultStory,
      stage
    );
  }
static MVINPC_MiningChild(stage) {
    return new Character(
      "MVINPC_MiningChild",
      Glyphs.MVINPC_MiningChild,
      8,
      {"look":"A small boy dressed in too large mining overalls sits, {moreDetail}","bump":"{barkDetail}","moreDetail":["his pick laying across his legs.","his pack behind him.","collecting himself on the cold hard ground."],"barkDetail":["The child continues to sob inconsolably."]},
      MVINPC_MiningChildStory,
      stage
    );
  }
static MVINPC_Nun(stage) {
    return new Character(
      "MVINPC_Nun",
      Glyphs.MVINPC_Nun,
      8,
      {"look":"A lady dreesed in a long flowing white robe, {moreDetail}","bump":"{barkDetail}","moreDetail":["standing over a group of children.","reading from the holy scripture.","standing in prayer."],"barkDetail":["Hallowed be the Lord above!"]},
      MVINPC_NunStory,
      stage
    );
  }
static MVINPC_Sherif_Alden(stage) {
    return new Character(
      "MVINPC_Sherif_Alden",
      Glyphs.MVINPC_Sherif_Alden,
      8,
      {"look":"A tall man dressed in leather slacks, with a gun holdered at his hip, {moreDetail}","bump":"{barkDetail}","moreDetail":["inspecting the corpse on the ground.","talking to the assembled miners.","writing notes in a book."],"barkDetail":["Goodbye."]},
      MVINPC_Sherif_AldenStory,
      stage
    );
  }
static MVINPC_Timmy(stage) {
    return new Character(
      "MVINPC_Timmy",
      Glyphs.MVINPC_Timmy,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["A mangled, charred corpse slowly decaying amongst the shattered rock."],"barkDetail":["What a terrible sight."]},
      MVINPC_TimmyStory,
      stage
    );
  }
static inDemand(stage) {
    return new Character(
      "inDemand",
      Glyphs.InDemand,
      8,
      {"look":"A Miner, {moreDetail}","bump":"{barkDetail}","moreDetail":["by the looks of his dwellings. There's loose gear and dirty workboots strewn about the place.","who hasn't heard of washing his hands, it seems.","with an injured shoulder, covered in a bandage."],"barkDetail":["“You're not from around here, are you?”","“It's hard on the shoulders breaking stone every day in the mines, I can tell ya that!”","“Been so long since I've had a holiday. At least I can rest up for a bit now.”","(Groans in pain.)"]},
      inDemandStory,
      stage
    );
  }
static stripTheValley(stage) {
    return new Character(
      "stripTheValley",
      Glyphs.StripTheValley,
      8,
      {"look":"An old Miner, {moreDetail}","bump":"{barkDetail}","moreDetail":["heaving bags of his posessions onto the dock.","breathing heavily and with grim determination.","whose strong hands have turned frail, and shaky."],"barkDetail":["(Grunts)","“We'll survive.”","“No use fighting change, friend.”","“Leave an old man be.”","“(Grunts)”"]},
      stripTheValleyStory,
      stage
    );
  }
static hermTheHermit(stage) {
    return new Character(
      "hermTheHermit",
      Glyphs.HermTheHermit,
      8,
      {"look":"A {descriptive} hermit {moreDetail}","bump":"{barkDetail}","descriptive":["dirty-looking, elderly","grey-haired, bearded","broken-bodied"],"moreDetail":["spooling a fishing line.","watching the water in silence.","lost in his own thoughts."],"barkDetail":["“Why, hello there!”","“Great day fer some fishin', don'cha think?”","“Looks like another day of great weather.”","“Care to pass the time fishin' in tranquility with this ol' man?”"]},
      hermTheHermitStory,
      stage
    );
  }
static treasure(stage) {
    return new Character(
      "treasure",
      Glyphs.Treasure,
      8,
      {"look":"A cavern full of history.","bump":"{barkDetail}","barkDetail":["You stand and take in the carvings on the walls.","You stumble into the pile of sticks.","There was never a golden horde..."]},
      treasureStory,
      stage
    );
  }
static grasstotem(stage) {
    return new Character(
      "grasstotem",
      Glyphs.Grasstotem,
      8,
      {"look":"A ruined totem, with a red gem upon its top.","bump":"{barkDetail}","barkDetail":["The empty hole in the ground is full of webs.","Spiders crawl through the cracks around the totem.","The gem above is cracked and muddy."]},
      grasstotemStory,
      stage
    );
  }
static stonetotem(stage) {
    return new Character(
      "stonetotem",
      Glyphs.Stonetotem,
      8,
      {"look":"The totem is badly eroded like the cave rocks and stones have over the years.","bump":"{barkDetail}","barkDetail":["Cave insects scatter at the sight of you.","A dull purple gem is barley visible in the rubble.","This ruin has not been touched in many years."]},
      stonetotemStory,
      stage
    );
  }
static bonVoyage(stage) {
    return new Character(
      "bonVoyage",
      Glyphs.BonVoyage,
      8,
      {"look":"Captain's Log: The Voyage of the Oddsea.","bump":"{barkDetail}","barkDetail":["“And we're off!”","“Ay, Captain!”","“Set sail for the Inlet's Maw!”","(The crew begin singing sea shanties.)","“Let loose the sail!”"]},
      bonVoyageStory,
      stage
    );
  }
static drowningSailor(stage) {
    return new Character(
      "drowningSailor",
      Glyphs.DrowningSailor,
      8,
      {"bump":"Debris from what looks like a Merchant Vessel, {moreDetail}","look":"Debris from what looks like a Merchant Vessel...","moreDetail":["where we found an unconscious Sailor adrift.","which appears to have drifted in from a faraway land.","that certainly didn't originate in Caldera."]},
      drowningSailorStory,
      stage
    );
  }
static pirateBattle(stage) {
    return new Character(
      "pirateBattle",
      Glyphs.PirateBattle,
      8,
      {"look":"A ship, {moreDetail}","bump":"{barkDetail}","moreDetail":["flying black sails.","with raucous shouts and jubilant cheers eminating in the distance."],"barkDetail":["“That should teach 'em not t'mess with us!”","“Arr! Let tha' be a lesson for ye!”","“Them that dies, be the lucky ones!”","(The crew cheers!)"]},
      pirateBattleStory,
      stage
    );
  }
static seaBeast(stage) {
    return new Character(
      "seaBeast",
      Glyphs.SeaBeast,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["“Captain! A disturbance in th' water!”","“Something's breaking waves, Captain! Should we approach't?”","An unusual sighting, which could not be made out at this distance."],"barkDetail":["“What... was that, Captain?”","“Is it still beneath us?”","“We should make port, Captain!”","“Is it after us?!”","“I doubt we'll make contact again soon, let us make sail back to Caldera!”"]},
      seaBeastStory,
      stage
    );
  }
static unusualWreck(stage) {
    return new Character(
      "unusualWreck",
      Glyphs.UnusualWreck,
      8,
      {"look":"An Unusual Wreckage...","bump":"{barkDetail}","barkDetail":["“What... is this?”","“Should we investigate, Captain?”","“What could have done this?”"]},
      unusualWreckStory,
      stage
    );
  }
static captainbob(stage) {
    return new Character(
      "captainbob",
      Glyphs.Captainbob,
      8,
      {"look":"A pirate captain, {moreDetail}","bump":"{barkDetail}","moreDetail":["with the look of someone who has seen things no person should have seen.","with an aura of experience and respect."],"barkDetail":["“You want to know about my past? Ok, I'll tell you, but only if you give me something in return. How about you tell me about your past?”","“Why don't I have a parrot you ask? I do, he's just very antisocial and refuses to leave my room.”"]},
      captainbobStory,
      stage
    );
  }
static secretWizard(stage) {
    return new Character(
      "secretWizard",
      Glyphs.SecretWizard,
      8,
      {"look":"A Wizard! {moreDetail}","bump":"{barkDetail}","moreDetail":["OOhoOHoooOOHHOOhhhhhh!","Zim! ZAm!! Zooinggg!","He hasn't washed in weeks!"],"barkDetail":["“I used to be a standup comedian, you know.”","“You may have heard of me? No, you wouldn't have heard of me...”","“I mostly just hang around in caves now...”","“I'm between jobs at the moment. It's only temporary.”","“I've been here... uhhhh, seven months? Not that long.”","“Yes, I know it's not a physical Ring. I was just making a reference.”","“Yes, I know this isn't a castle, you don't have to rub it in.”","“Are you just going to stand there or are you going to try this bad boy?”","“It took me a long time to dig out this cave. Had to do it with only half a shovel! The stick half, sadly. The other bit broke off and I lost it. I regret not keeping the receipt.”","“I promise the coffin's not dirty, it's only been used once.”","“Boy oh boy, look at the time! Might have to have a nap. You can sleep in the coffin, if you like.”","“Are you hungry? I think I had some leftovers at the back of the coffin, take a look.”","“Just get in the coffin, please. I swear it's not a trick. And I know that sounds suspicious, but it's not!”","“You ever wonder what it's like to lie in one of these things? Most people only do it once.”","“Come on, live a little! Oh... sorry, that's insensitive of me.”","“What, this? This was here when I got here. I just found it like this. You can have it if you want though.”","“Oh, you know, I think I see the glint of something shiny nestled inside the coffin! Maybe that's the Elden Ring?”","“I'll get in if you do.”","“How about, we both close our eyes, and get in the coffin at the same time?”","“Oh, man, I just got back from a coffin vacay, it was so good, but I'm sure you wouldn't be interested in that, whatever.”","“Please, the coffin's very sick, it could die if you don't get in.”","“Go on, do it for a laugh. ...Please?”"]},
      secretWizardStory,
      stage
    );
  }
}

export function spawnCharacters(stage) {
  stage.spawnEntity(Characters.belgrano(), 364, 173);
  stage.spawnEntity(Characters.belgranosKeys(), 377, 146);
  stage.spawnEntity(Characters.edwards(), 364, 129);
  stage.spawnEntity(Characters.garren(), 365, 172);
  stage.spawnEntity(Characters.lee(), 353, 136);
  stage.spawnEntity(Characters.rangefinder(), 369, 171);
  stage.spawnEntity(Characters.differentVeil(), 279, 271);
  stage.spawnEntity(Characters.fogSighter(), 281, 236);
  stage.spawnEntity(Characters.helmsman(), 257, 243);
  stage.spawnEntity(Characters.navigator(), 298, 267);
  stage.spawnEntity(Characters.quartermaster(), 280, 257);
  stage.spawnEntity(Characters.salvager(), 277, 269);
  stage.spawnEntity(Characters.seaCaptain(), 284, 242);
  stage.spawnEntity(Characters.boy(), 291, 141);
  stage.spawnEntity(Characters.mother(), 296, 144);
  stage.spawnEntity(Characters.shouldTheyTry(), 287, 162);
  stage.spawnEntity(Characters.suspiciousMan(), 335, 181);
  stage.spawnEntity(Characters.takeAMoment(), 274, 133);
  stage.spawnEntity(Characters.wolfLeader(), 0, 0);
  stage.spawnEntity(Characters.bridgeperson(), 316, 286);
  stage.spawnEntity(Characters.explorer(), 397, 305);
  stage.spawnEntity(Characters.professor(), 352, 262);
  stage.spawnEntity(Characters.tunneltotem(), 403, 259);
  stage.spawnEntity(Characters.iris(), 85, 190);
  stage.spawnEntity(Characters.villagehead(), 35, 222);
  stage.spawnEntity(Characters.garland(), 198, 113);
  stage.spawnEntity(Characters.MVINPC_EvidanceBox(), 154, 59);
  stage.spawnEntity(Characters.MVINPC_FatherDavid(), 140, 58);
  stage.spawnEntity(Characters.MVINPC_MayorHamish(), 157, 81);
  stage.spawnEntity(Characters.MVINPC_MineEntranceMan(), 143, 109);
  stage.spawnEntity(Characters.MVINPC_MiningAdult(), 102, 71);
  stage.spawnEntity(Characters.MVINPC_MiningChild(), 104, 68);
  stage.spawnEntity(Characters.MVINPC_Nun(), 137, 57);
  stage.spawnEntity(Characters.MVINPC_Sherif_Alden(), 112, 74);
  stage.spawnEntity(Characters.MVINPC_Timmy(), 77, 82);
  stage.spawnEntity(Characters.inDemand(), 94, 131);
  stage.spawnEntity(Characters.stripTheValley(), 140, 167);
  stage.spawnEntity(Characters.hermTheHermit(), 199, 165);
  stage.spawnEntity(Characters.treasure(), 313, 358);
  stage.spawnEntity(Characters.grasstotem(), 111, 351);
  stage.spawnEntity(Characters.stonetotem(), 269, 50);
  stage.spawnEntity(Characters.bonVoyage(), 257, 238);
  stage.spawnEntity(Characters.drowningSailor(), 398, 199);
  stage.spawnEntity(Characters.pirateBattle(), 417, 57);
  stage.spawnEntity(Characters.seaBeast(), 442, 18);
  stage.spawnEntity(Characters.unusualWreck(), 413, 113);
  stage.spawnEntity(Characters.captainbob(), 196, 218);
  stage.spawnEntity(Characters.secretWizard(), 334, 18);
}

export default Characters;
